import {
  Accordion,
  AccordionSummary,
  Grid,
  Typography,
  styled,
} from '@mui/material';

export const CoverageContainer = styled(Grid)(() => ({
  marginTop: '40px',
  border: '1px solid #D7D8DB',
  borderRadius: '8px',
  padding: '40px',
}));

export const CoverageTitle = styled(Typography)(() => ({
  fontFamily: 'Montserrat',
  fontSize: '18px',
  color: '#8B8C8E',
  fontWeight: 500,
}));

export const CityInfoContainer = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  marginBottom: '16px',
}));

export const CityText = styled(Typography)(() => ({
  fontFamily: 'Montserrat',
  fontSize: '16px',
  color: '#8B8C8E',
  fontWeight: 500,
}));

export const DisplacementText = styled(Typography)(() => ({
  fontFamily: 'Montserrat',
  fontSize: '16px',
  color: '#8B8C8E',
  fontWeight: 500,
}));

export const DisplacementValue = styled('span')(() => ({
  fontFamily: 'Montserrat',
  fontSize: '16px',
  color: '#707070',
  fontWeight: 600,
}));

export const StyledAccordion = styled(Accordion)(() => ({
  boxShadow: 'none',
  '&:before': {
    display: 'none',
  },
  width: '100%',
  backgroundColor: 'transparent',
}));

export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  minHeight: '70px',
  height: '70px',
  margin: '0',

  // Remove todas as transições do summary
  transition: 'none !important',

  '& .MuiAccordionSummary-content': {
    margin: '0 !important',
    transition: 'none',
  },

  // Remove margens quando expandido
  '&.Mui-expanded': {
    minHeight: '70px',
    margin: '0 !important',

    '& .MuiAccordionSummary-content': {
      margin: '0 !important',
    },
  },

  // Estilo para o ícone de expandir
  '& .expandIcon': {
    color: theme.palette.primary.main,
    marginLeft: '12px',
    transition: 'transform 0.3s ease',
    display: 'inline-flex',
    '& span': {
      fontWeight: 700,
    },

    '.Mui-expanded &': {
      transform: 'rotate(180deg)',
    },
  },
}));

export const ContentContainer = styled('div')(() => ({
  paddingLeft: '32px',
  paddingTop: '6px',
  paddingBottom: '10px',
}));

export const AccordionTitle = styled(Typography)(() => ({
  fontSize: '18px',
  fontWeight: 700,
  display: 'flex',
  alignItems: 'center',
}));

export const ScrollableGrid = styled(Grid)(() => ({
  width: '96%',
  maxHeight: '400px',
  overflowY: 'scroll',
  borderRadius: '6px',
  '& > .MuiGrid-item': {
    width: '100%',
    display: 'block',
  },

  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#8B8C8E',
    borderRadius: '4px',
  },
}));
